<template>
  <section
    v-if="tagListingFilterGroups.length > 0"
    class="tag-listing-filters"
  >
    <div class="tag-listing-filters-wrapper">
      <BaseGroupListingFilters
        v-if="tagListingFilterGroups.length > 0"
        :base-group-combos="tagListingFilterGroups"
      >
      </BaseGroupListingFilters>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseGroupListingFilters from '../Components/BaseGroupListingFilters'

export default {
  name: 'TagListingFilters',
  props: [],
  components: {
    BaseGroupListingFilters
  },
  computed: {
    ...mapGetters([
      'getListingTagGroupCombos',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getActiveTagFilters',
      'config'
    ]),
    tagListingFilterGroups () {
      const groups = this.getListingTagGroupCombos
      groups.forEach(group => {
        group.tags.sort((a, b) => {
          return a.tagOrder - b.tagOrder
        })
      })
      return groups.sort((a, b) => {
        return a.tagGroupOrder - b.tagGroupOrder
      })
    }
  }
}
</script>
